import { FunctionComponent, useContext, useEffect } from 'react'
import { UserContext } from '../contexts/user'
import { parseOrgPath } from '../url/orgPath'
import { loginUrl, renewAuthToken, renewSessionAuthToken } from './auth0'
import { OrgPathGuard } from './OrgPathGuard'

const withAuth = (
  InnerComponent: FunctionComponent<any>
): FunctionComponent => {
  return function Page(props) {
    const { user, orgless } = useContext(UserContext)

    const here = `${window.location.pathname}${window.location.search}`

    // Signed in, but with no org yet (a fresh sign-up): onboarding gives
    // them one.
    if (!user && orgless) {
      return <RedirectTo uri="/onboarding" />
    }

    // Signed out: the SSO orchestrator's universal login, then back here,
    // in the org the address names.
    if (!user) {
      return (
        <RedirectTo
          uri={loginUrl({ returnTo: here, orgId: parseOrgPath(here).orgId })}
        />
      )
    }

    return (
      <>
        <AuthTokenChecker />
        {/* The URL's `/orgs/<id>` is settled before the page renders at all. */}
        <OrgPathGuard>
          <InnerComponent {...props} />
        </OrgPathGuard>
      </>
    )
  }
}

const RedirectTo: FunctionComponent<{ uri: string }> = ({ uri }) => {
  window.location.assign(uri)
  return null
}

const AuthTokenChecker: FunctionComponent = () => {
  useEffect(() => {
    const interval = setInterval(
      () => renewAuthToken().then(() => renewSessionAuthToken()),
      10000
    )
    return () => clearInterval(interval)
  }, [])

  return null
}

export default withAuth
